import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface ConfirmDeleteGameModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  gameTitle: string;
}

const ConfirmDeleteGameModal = ({
  show,
  onHide,
  onConfirm,
  gameTitle,
}: ConfirmDeleteGameModalProps) => {
  return (
    <Dialog open={show} onClose={onHide} maxWidth="xs" fullWidth>
      <DialogTitle>Confirm Deletion</DialogTitle>

      <DialogContent dividers>
        <Typography>
          Are you sure you want to delete <strong>{gameTitle}</strong>?
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onHide}>Cancel</Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteGameModal;